import { useState } from "react";
import { Modal } from "react-bootstrap";
import { t } from "../../../i18n";

export type TransactionActionType = "approve" | "reject";

interface Props {
    mode: TransactionActionType | null;
    onConfirm: (reason: string) => void;
    onCancel: () => void;
}

export function AdminTransactionConfirmModal({ mode, onConfirm, onCancel }: Props) {
    const [reason, setReason] = useState("");

    const handleCancel = () => {
        setReason("");
        onCancel();
    };

    const handleConfirm = () => {
        onConfirm(reason);
        setReason("");
    };

    return (
        <Modal show={mode !== null} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {mode === "approve" && t("adminTransactions.approve.title")}
                    {mode === "reject" && t("adminTransactions.reject.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {mode === "approve" && t("adminTransactions.approve.description")}
                {mode === "reject" && (
                    <div className="form-group">
                        <label htmlFor="reject-reason-textarea">{t("adminTransactions.reject.reasonLabel")}</label>
                        <textarea
                            id="reject-reason-textarea"
                            className="form-control"
                            value={reason}
                            onChange={(event) => setReason(event.target.value)}
                            placeholder={t("adminTransactions.reject.reasonPlaceholder")}
                            rows={3}
                        />
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={handleCancel}>
                    {t("button.cancel")}
                </button>
                <button
                    className={mode === "approve" ? "btn btn-success" : "btn btn-danger"}
                    disabled={mode === "reject" && !reason.trim()}
                    onClick={handleConfirm}
                >
                    {t("button.confirm")}
                </button>
            </Modal.Footer>
        </Modal>
    );
}
